import React from 'react'
import { StyledSwitch } from './switchComponent.style';

export interface ISwitch {
  commonStyles?: any;
  label?: any;
  labelPlacement?: any;
  className?: any;
  checked?: any;
  id?: any;
  onChange?: () => void; 
}


const SwitchComponent: React.FC<ISwitch> = (props) => {

  const { commonStyles, label, labelPlacement, className, checked, onChange, id} = props

  return (
    <StyledSwitch
        id={id}
        commonStyles={commonStyles}
        label={label}
        labelPlacement={labelPlacement}
        className={className}
        checked={checked}
        onChange={onChange}
        inputProps={{
          "aria-label": 'switch input',
          "aria-checked": checked,
        }}
    />
  )
}

export const defaultProps = {

}

export default SwitchComponent;